module.exports = __webpack_public_path__ + "static/media/TopDelivery2_3.f6cba47b.png";